import { useEffect } from "react";
import { brandSettings } from "../../settings/BrandSettings";

export const TidioChat = () => {
    useEffect(() => {
        if (brandSettings.showHelp !== false) {
            const script = document.createElement("script");
            script.src = `//code.tidio.co/lwfl92niav1idwyxpiupvhnyvdrnm7ny.js`;
            script.async = true;
            document.body.appendChild(script);

            return () => {
                document.body.removeChild(script); // Cleanup on unmount
            };
        }
    }, []);
    return null;
};

interface TidioUser {
   
    userId?: string;
    email?: string;
    name?: string;
    phone?: string;
  }
  
  interface TidioContactProperties {
    biz_id?: string;
    user_id?: string;

  }
  
  declare global {
    interface Window {
      tidioChatApi?: {
        setVisitorData: (data: Partial<TidioUser>) => void;
        setContactProperties: (properties: TidioContactProperties) => void;
      };
    }
  }

export const updateTidioUser = (userData: any) => {
    if (window.tidioChatApi) {
        window.tidioChatApi.setVisitorData({
            email: userData.email, // Email
            userId:userData.userId,
            name: userData.name, // Name
            phone: userData.phone, // Phone
        });
        window.tidioChatApi.setContactProperties({
            user_id:userData.user_id,
            biz_id:userData.distinct_id
        })
    }
};


